import { HttpContextToken } from '@angular/common/http';

/** Marks an HTTP request that has already been retried once after a token refresh. */
export const RETRIED_AFTER_REFRESH = new HttpContextToken<boolean>(() => false);
